module.exports = __webpack_public_path__ + "static/media/different-treatments.fff97e08.svg";